import { IRoleAccessRuleLang } from '../../../types/lang'

export const roleAccessRuleLang: IRoleAccessRuleLang = {
	role_access_rule: {
		title_label_access: 'Access',

		any_name: 'Any access',
		any_tooltip: 'Allows maximal access to system.',
		api_health_check_name: 'Api Health Check',
		api_health_check_tooltip: 'Allows api health check.',
		api_postback_send_name: 'Postback Send',
		api_postback_send_tooltip: 'Allows <icon /> api send postback.',

		auth_login_name: 'System Login access',
		auth_login_tooltip: 'Allows login to system.',
		auth_profile_name: 'System Profile access',
		auth_profile_tooltip: 'Allows fetching profile data in system.<br />Used over all in system.',

		common_country_any_name: 'Countries any access',
		common_country_any_tooltip: 'Allows all actions on countries in system.',
		common_country_list_name: 'Countries list access',
		common_country_list_tooltip: 'Allows get countries list in system.<br />Used in {{menuTitle}} filters.',
		common_country_read_name: 'Countries read access',
		common_country_read_tooltip: 'Allows get country by code in system.<br />Not used.',

		common_language_any_name: 'Languages any access',
		common_language_any_tooltip: 'Allows all actions on language\'s in system.',
		common_language_list_name: 'Languages list access',
		common_language_list_tooltip: 'Allows get language\'s list in system.<br />Not used.',
		common_language_read_name: 'Languages read access',
		common_language_read_tooltip: 'Allows get language by code in system.<br />Not used.',

		common_time_zone_any_name: 'Time zones any access',
		common_time_zone_any_tooltip: 'Allows all actions on time zone\'s in system.',
		common_time_zone_list_name: 'Time zones list access',
		common_time_zone_list_tooltip: 'Allows get time zone\'s list in system.<br />Not used.',
		common_time_zone_read_name: 'Time zones read access',
		common_time_zone_read_tooltip: 'Allows get time zone by code in system.<br />Not used.',

		role_any_name: 'Role any',
		role_any_tooltip: 'Allows all actions on <icon /> role\'s in system.<br />Used in {{menuTitle}}.',
		role_list_name: 'Role list',
		role_list_tooltip: 'Allows get list of <icon /> role\'s.<br />Used in {{menuTitle}}.',
		role_read_name: 'Role read',
		role_read_tooltip: 'Allows get single <icon /> role.<br />Used in {{menuTitle}}.',
		role_create_name: 'Role create',
		role_create_tooltip: 'Allows create new <icon /> role.<br />Used in {{menuTitle}}.',
		role_modify_name: 'Role modify',
		role_modify_tooltip: 'Allows modify <icon /> role.<br />Used in {{menuTitle}}.',
		role_remove_name: 'Role remove',
		role_remove_tooltip: 'Allows remove <icon /> role.<br />Used in {{menuTitle}}.',

		account_any_name: 'Account any',
		account_any_tooltip: 'Allows all actions on <icon /> account\'s in system.<br />Used in {{menuTitle}}.',
		account_list_name: 'Account list',
		account_list_tooltip: 'Allows get list of <icon /> account\'s.<br />Used in {{menuTitle}}.',
		account_is_fired_list_name: 'Account fired list',
		account_is_fired_list_tooltip: 'Allows get list of <icon /> fired account\'s.<br />Used in {{menuTitle}}.',
		account_read_name: 'Account read',
		account_read_tooltip: 'Allows get single <icon /> account.<br />Used in {{menuTitle}}.',
		account_create_name: 'Account create',
		account_create_tooltip: 'Allows create new <icon /> account.<br />Used in {{menuTitle}}.',
		account_modify_name: 'Account modify',
		account_modify_tooltip: 'Allows modify <icon /> account.<br />Used in {{menuTitle}}.',
		account_remove_name: 'Account remove',
		account_remove_tooltip: 'Allows remove <icon /> account.<br />Used in {{menuTitle}}.',
		account_resurrect_name: 'Account resurrect',
		account_resurrect_tooltip: 'Allows resurrect removed <icon /> account.<br />Used in {{menuTitle}}.',

		account_buyer_any_name: 'Account buyer any',
		account_buyer_any_tooltip: 'Allows all actions on buyer\'s in system.<br />Used in {{menuTitle_1}} and {{menuTitle_2}}.',
		account_buyer_self_name: 'Account buyer self only',
		account_buyer_self_tooltip: 'Allows get single buyer in list only.<br />Used in {{menuTitle_1}} and {{menuTitle_2}}.',
		account_buyer_list_name: 'Account buyer list',
		account_buyer_list_tooltip: 'Allows get list of buyer\'s.<br />Used in {{menuTitle_1}} and {{menuTitle_2}}.',

		account_team_any_name: 'Account team any',
		account_team_any_tooltip: 'Allows all actions on team\'s in system.<br />Used in {{menuTitle}}.',
		account_team_self_name: 'Account team self only',
		account_team_self_tooltip: 'Allows get single team in list only.<br />Used in {{menuTitle}}',
		account_team_list_name: 'Account team list',
		account_team_list_tooltip: 'Allows get list of team\'s.<br />Used in {{menuTitle}}',

		affiliate_any_name: 'Affiliate any',
		affiliate_any_tooltip: 'Allows all actions on <icon /> affiliate\'s in system.<br />Used in {{menuTitle}}.',
		affiliate_list_name: 'Affiliate list',
		affiliate_list_tooltip: 'Allows get list of <icon /> affiliate\'s.<br />Used in {{menuTitle}}.',
		affiliate_read_name: 'Affiliate read',
		affiliate_read_tooltip: 'Allows get single <icon /> affiliate.<br />Used in {{menuTitle}}.',
		affiliate_create_name: 'Affiliate create',
		affiliate_create_tooltip: 'Allows create new <icon /> affiliate.<br />Used in {{menuTitle}}.',
		affiliate_modify_name: 'Affiliate modify',
		affiliate_modify_tooltip: 'Allows modify <icon /> affiliate.<br />Used in {{menuTitle}}.',
		affiliate_remove_name: 'Affiliate remove',
		affiliate_remove_tooltip: 'Allows remove <icon /> affiliate.<br />Used in {{menuTitle}}.',

		offer_scope_any_name: 'Offer scope any',
		offer_scope_any_tooltip: 'Allows all actions on <icon /> offer scope\'s in system.<br />Used in {{menuTitle}}.',
		offer_scope_list_name: 'Offer scope list',
		offer_scope_list_tooltip: 'Allows get list of <icon /> offer scope\'s.<br />Used in {{menuTitle}}.',
		offer_scope_read_name: 'Offer scope read',
		offer_scope_read_tooltip: 'Allows get single <icon /> offer scope.<br />Used in {{menuTitle}}.',
		offer_scope_create_name: 'Offer scope create',
		offer_scope_create_tooltip: 'Allows create new <icon /> offer scope.<br />Used in {{menuTitle}}.',
		offer_scope_modify_name: 'Offer scope modify',
		offer_scope_modify_tooltip: 'Allows modify <icon /> offer scope.<br />Used in {{menuTitle}}.',
		offer_scope_remove_name: 'Offer scope remove',
		offer_scope_remove_tooltip: 'Allows remove <icon /> offer scope.<br />Used in {{menuTitle}}.',

		offer_any_name: 'Offer any',
		offer_any_tooltip: 'Allows all actions on <icon /> offer\'s in system.<br />Used in {{menuTitle}}.',
		offer_any_group_name: 'Offer any group',
		offer_any_group_tooltip: 'Allows get list of <icon /> offer\'s in any group.<br />Used in {{menuTitle}}.',
		offer_list_name: 'Offer list',
		offer_list_tooltip: 'Allows get list of <icon /> offer\'s.<br />Used in {{menuTitle}}.',
		offer_read_name: 'Offer read',
		offer_read_tooltip: 'Allows get single <icon /> offer.<br />Used in {{menuTitle}}.',
		offer_create_name: 'Offer create',
		offer_create_tooltip: 'Allows create new <icon /> offer.<br />Used in {{menuTitle}}.',
		offer_modify_name: 'Offer modify',
		offer_modify_tooltip: 'Allows modify <icon /> offer.<br />Used in {{menuTitle}}.',
		offer_remove_name: 'Offer remove',
		offer_remove_tooltip: 'Allows remove <icon /> offer.<br />Used in {{menuTitle}}.',
		offer_resurrect_name: 'Offer resurrect',
		offer_resurrect_tooltip: 'Allows resurrect removed <icon /> offer.<br />Used in {{menuTitle}}.',
		offer_bind_name: 'Offer bind',
		offer_bind_tooltip: 'Allows binding <icon /> offer to scope.<br />Used in {{menuTitle}}.',
		offer_unbind_name: 'Offer unbind',
		offer_unbind_tooltip: 'Allows unbind <icon /> offer from scope.<br />Used in {{menuTitle}}.',

		offer_spend_any_name: 'Offer Spend any',
		offer_spend_any_tooltip: 'Allows all actions on <icon /> offer spend\'s in system.<br />Used in {{menuTitle}}.',
		offer_spend_any_account_name: 'Offer Spend any account',
		offer_spend_any_account_tooltip: 'Allows edit on <icon /> offer spend\'s by any account.<br />Used in {{menuTitle}} Create / Edit.',
		offer_spend_any_day_name: 'Offer Spend any day',
		offer_spend_any_day_tooltip: 'Allows edit on <icon /> offer spend\'s at any date.<br />Used in {{menuTitle}} Create / Edit.',
		offer_spend_any_group_name: 'Offer Spend any group',
		offer_spend_any_group_tooltip: 'Allows edit on <icon /> offer spend\'s by offer in any group.<br />Used in {{menuTitle}} Create / Edit.',
		offer_spend_list_name: 'Offer Spend list',
		offer_spend_list_tooltip: 'Allows get list of <icon /> offer spend\'s.<br />Used in {{menuTitle}}.',
		offer_spend_read_name: 'Offer Spend read',
		offer_spend_read_tooltip: 'Allows get single <icon /> offer spend.<br />Used in {{menuTitle}}.',
		offer_spend_create_name: 'Offer Spend create',
		offer_spend_create_tooltip: 'Allows create new <icon /> offer spend.<br />Used in {{menuTitle}}.',
		offer_spend_modify_name: 'Offer Spend modify',
		offer_spend_modify_tooltip: 'Allows modify <icon /> offer spend.<br />Used in {{menuTitle}}.',
		offer_spend_remove_name: 'Offer Spend remove',
		offer_spend_remove_tooltip: 'Allows remove <icon /> offer spend.<br />Used in {{menuTitle}}.',

		offer_spend_by_any_name: 'Offer Spend by any',
		offer_spend_by_any_tooltip: 'Allows all actions on <icon /> offer spend report\'s in system.<br />Used in {{menuTitle}}.',
		offer_spend_by_account_list_name: 'Offer Spend by account list',
		offer_spend_by_account_list_tooltip: 'Allows get report <icon /> offer spend by account.',
		offer_spend_by_offer_list_name: 'Offer Spend by offer list',
		offer_spend_by_offer_list_tooltip: 'Allows get report <icon /> offer spend by offer.',
		offer_spend_by_offer_scope_list_name: 'Offer Spend by scope list',
		offer_spend_by_offer_scope_list_tooltip: 'Allows get report <icon /> offer spend by offer scope.',

		revenue_any_name: 'Revenue any',
		revenue_any_tooltip: 'Allows all actions on <icon /> Revenue\'s in system.<br />Used in {{menuTitle}}.',
		revenue_list_name: 'Revenue list',
		revenue_list_tooltip: 'Allows get list of <icon /> revenue\'s.<br />Used in {{menuTitle}}.',
		revenue_read_name: 'Revenue read',
		revenue_read_tooltip: 'Allows get single <icon /> revenue.<br />Used in {{menuTitle}}.',
		revenue_create_name: 'Revenue create',
		revenue_create_tooltip: 'Allows create new <icon /> revenue.<br />Used in {{menuTitle}}.',
		revenue_modify_name: 'Revenue modify',
		revenue_modify_tooltip: 'Allows modify <icon /> revenue.<br />Used in {{menuTitle}}.',
		revenue_remove_name: 'Revenue remove',
		revenue_remove_tooltip: 'Allows remove <icon /> revenue.<br />Used in {{menuTitle}}.',

		revenue_agency_any_name: 'Revenue Agency any',
		revenue_agency_any_tooltip: 'Allows all actions on <icon /> revenue agency\'s in system.<br />Used in {{menuTitle}}.',
		revenue_agency_list_name: 'Revenue Agency list',
		revenue_agency_list_tooltip: 'Allows get list of <icon /> revenue agency\'s.<br />Used in {{menuTitle}}.',
		revenue_agency_read_name: 'Revenue Agency read',
		revenue_agency_read_tooltip: 'Allows get single <icon /> revenue agency.<br />Used in {{menuTitle}}.',
		revenue_agency_create_name: 'Revenue Agency create',
		revenue_agency_create_tooltip: 'Allows create new <icon /> revenue agency.<br />Used in {{menuTitle}}.',
		revenue_agency_modify_name: 'Revenue Agency modify',
		revenue_agency_modify_tooltip: 'Allows modify <icon /> revenue agency.<br />Used in {{menuTitle}}.',
		revenue_agency_remove_name: 'Revenue Agency remove',
		revenue_agency_remove_tooltip: 'Allows remove <icon /> revenue agency.<br />Used in {{menuTitle}}.',

		revenue_spend_any_name: 'Revenue Spend any',
		revenue_spend_any_tooltip: 'Allows all actions on <icon /> revenue spend\'s in system.<br />Used in {{menuTitle}}.',
		revenue_spend_list_name: 'Revenue Spend list',
		revenue_spend_list_tooltip: 'Allows get list of <icon /> revenue spend\'s.<br />Used in {{menuTitle}}.',
		revenue_spend_read_name: 'Revenue Spend read',
		revenue_spend_read_tooltip: 'Allows get single <icon /> revenue spend.<br />Used in {{menuTitle}}.',
		revenue_spend_create_name: 'Revenue Spend create',
		revenue_spend_create_tooltip: 'Allows create new <icon /> revenue spend.<br />Used in {{menuTitle}}.',
		revenue_spend_modify_name: 'Revenue Spend modify',
		revenue_spend_modify_tooltip: 'Allows modify <icon /> revenue spend.<br />Used in {{menuTitle}}.',
		revenue_spend_remove_name: 'Revenue Spend remove',
		revenue_spend_remove_tooltip: 'Allows remove <icon /> revenue spend.<br />Used in {{menuTitle}}.',

		revenue_spend_by_any_name: 'Revenue Spend by any',
		revenue_spend_by_any_tooltip: 'Allows all actions on <icon /> revenue spend report\'s in system.<br />Used in {{menuTitle_1}} or {{menuTitle_2}}.',
		revenue_spend_by_account_list_name: 'Revenue Spend by account list',
		revenue_spend_by_account_list_tooltip: 'Allows get report <icon /> revenue spend by account.',
		revenue_spend_by_accounts_list_name: 'Revenue Spend by accounts list',
		revenue_spend_by_accounts_list_tooltip: 'Allows get report <icon /> revenue spend by accounts.',
		revenue_spend_by_team_list_name: 'Revenue Spend by team list',
		revenue_spend_by_team_list_tooltip: 'Allows get report <icon /> revenue spend by team.',
		revenue_spend_by_teams_list_name: 'Revenue Spend by teams list',
		revenue_spend_by_teams_list_tooltip: 'Allows get report <icon /> revenue spend by teams.',

		debug_any_name: 'Debug any',
		debug_any_tooltip: 'Allows view all debug.',
		debug_cron_runner_name: 'Debug cron runner access',
		debug_cron_runner_tooltip: 'Allows cron runner via URI.',
		debug_draft_name: 'Draft access enabled',
		debug_draft_tooltip: 'Allows view draft\'s.',
		debug_message_name: 'Debug message enabled',
		debug_message_tooltip: 'Allows view debug message and trace on error\'s in console.',

		job_any_name: 'Job any',
		job_any_tooltip: 'Allows all actions on <icon /> job\'s in system.<br />Used in {{menuTitle}}.',
		job_list_name: 'Job list',
		job_list_tooltip: 'Allows get list of <icon /> job\'s.<br />Used in {{menuTitle}}.',
		job_read_name: 'Job read',
		job_read_tooltip: 'Allows get single <icon /> job.<br />Used in {{menuTitle}}.',
		job_create_name: 'Job create',
		job_create_tooltip: 'Allows create new <icon /> job.<br />Used in {{menuTitle}}.',
		job_modify_name: 'Job modify',
		job_modify_tooltip: 'Allows modify <icon /> job.<br />Used in {{menuTitle}}.',
		job_remove_name: 'Job remove',
		job_remove_tooltip: 'Allows remove <icon /> job.<br />Used in {{menuTitle}}.',

		project_any_name: 'Project any',
		project_any_tooltip: 'Allows all actions on <icon /> project\'s in system.<br />Used in {{menuTitle}}.',
		project_list_name: 'Project list',
		project_list_tooltip: 'Allows get list of <icon /> project\'s.<br />Used in {{menuTitle}}.',
		project_read_name: 'Project read',
		project_read_tooltip: 'Allows get single <icon /> project.<br />Used in {{menuTitle}}.',
		project_create_name: 'Project create',
		project_create_tooltip: 'Allows create new <icon /> project.<br />Used in {{menuTitle}}.',
		project_modify_name: 'Project modify',
		project_modify_tooltip: 'Allows modify <icon /> project.<br />Used in {{menuTitle}}.',
		project_remove_name: 'Project remove',
		project_remove_tooltip: 'Allows remove <icon /> project.<br />Used in {{menuTitle}}.'
	}
}